import { defineMessages } from 'react-intl-next';

export const i18n: {
	mercuryFilterFocusAreaUnderLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mercuryFilterFocusAreaUnderLabelPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mercuryFilterFocusAreaUnderLabelLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mercuryFilterFocusAreaUnderLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	mercuryFilterFocusAreaUnderLabel: {
		id: 'search-page.filters.names.focusAreaUnder',
		defaultMessage: 'Focus area under',
		description: 'Label for filtering by content under a focus area',
	},
	mercuryFilterFocusAreaUnderLabelPlaceholder: {
		id: 'search-page.mercury.filter.content.placeholder',
		defaultMessage: 'Find focus areas',
		description: 'Placeholder for content filter search input',
	},
	mercuryFilterFocusAreaUnderLabelLabelSelected: {
		id: 'search-page.mercury.filter.content.selected',
		defaultMessage: 'Selected',
		description: 'Focus filter content selected',
	},
	mercuryFilterFocusAreaUnderLabelUnselected: {
		id: 'search-page.mercury.filter.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Focus filter content unselected',
	},
});
